import PanelProfile from 'panels/profile/PanelProfile'
import React from 'react'

export default function LayoutProfile() {
    return (
        <div className='h-screen w-full'>
            <PanelProfile />
        </div>
    )
}
